import React from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import AuthHeader from "../../../../Helper/authHeader";
import * as Constants from "../../../../Helper/constants/constants";

const ForgetPasswordLab = () => {
    return (
        <div className="forget_password_screen">
            <AuthHeader
                header={Constants.FOGET_PASSWORD_HEADER}
                description={Constants.FOGET_PASSWORD_DESCRIPTION}
            />
            <Container>
                <Row>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                        <div className="form">
                            <Form>
                                <Form.Group className="form-group">
                                    <Form.Label>
                                        Enter your email address
                                    </Form.Label>
                                    <Form.Control
                                        type="email"
                                        placeholder="test@gmail.com"
                                    />
                                </Form.Group>
                                <Button
                                    type="submit"
                                >Send
                                </Button>
                            </Form>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default ForgetPasswordLab;